// src/routes/UserRoutes.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import NotFound from "../pages/static/NotFound";
import AdminLayout from "../layouts/AdminLayout";
import AdminDashboard from "../pages/admin/AdminDashboard";
import AdminLibrary from "../pages/admin/AdminLibrary";
import AdminCycles from "../pages/admin/AdminCycles";
import AdminTasks from "../pages/admin/AdminTasks";
import AdminAllMembers from "../pages/admin/AdminAllMembers";
import AdminLegacyFellows from "../pages/admin/AdminLegacyFellows";
import AdminRegionalReps from "../pages/admin/AdminRegionalReps";
import AdminInnerCircle from "../pages/admin/AdminInnerCircle";
import AdminMembers from "../pages/admin/AdminMembers";
import AdminAnalytics from "../pages/admin/AdminAnalytics";
import AdminAnnouncements from "../pages/admin/AdminAnnouncements";
import AdminRegion from "../pages/admin/AdminRegion";
import ViewEventRegister from "../pages/events/ViewEventRegister";

const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Layout Route */}
      <Route element={<AdminLayout />}>
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/team" element={<AdminMembers />} />
        <Route path="/regions" element={<AdminRegion />} />
        <Route path="/analytics" element={<AdminAnalytics />} />
        <Route path="/announcements" element={<AdminAnnouncements />} />
        <Route path="/programme/library" element={<AdminLibrary />} />
        <Route path="/programme/cycles" element={<AdminCycles />} />
        <Route path="/programme/tasks" element={<AdminTasks />} />
        <Route path="/members/all" element={<AdminAllMembers />} />
        <Route path="/members/fellows" element={<AdminLegacyFellows />} />
        <Route path="/members/reps" element={<AdminRegionalReps />} />
        <Route path="/members/inner-circle" element={<AdminInnerCircle />} />

        <Route path="/events" element={<ViewEventRegister />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
